// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v5SN","label":"styles_label__2tY7v"};